import React from 'react';
import '../root.css';
import '../css/RoyalsfPage.css';
import SEO from '../components/SEO';

function RoyalsfPage() {
    return (
        <>
            <SEO
                title="Royal S.F. - E-commerce Platform | Samuel Banczík"
                description="Royal S.F. is an e-commerce platform built by Samuel Banczík for a student-run business, with a complete product catalogue, secure online payments and automated order confirmation emails."
                keywords="Royal S.F., e-commerce, online store, Stripe payments, Next.js, student business, Samuel Banczík"
                url="https://banczik.com/royalsf"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "Royal S.F.",
                    // The entity lives on its own domain; this page only describes it.
                    "url": "https://royalsf.banczik.com",
                    "sameAs": "https://royalsf.banczik.com",
                    "mainEntityOfPage": "https://banczik.com/royalsf",
                    "author": {
                        "@type": "Person",
                        "name": "Samuel Banczík",
                        "url": "https://banczik.com"
                    },
                    "description": "E-commerce platform for a student-run business with a product catalogue and secure online payments",
                    "breadcrumb": {
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
                            { "@type": "ListItem", "position": 2, "name": "Royal S.F.", "item": "https://banczik.com/royalsf" }
                        ]
                    }
                }}
            />
            <div>RoyalsfPage</div>
        </>
    )
}

export default RoyalsfPage